"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_stack_1 = require("@react-navigation/native-stack");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Follow_1 = require("../screens/Follow/Follow");
const FollowScreen_1 = __importDefault(require("../screens/Follow/FollowScreen"));
const FollowTag_1 = require("../screens/Follow/FollowTag");
const Followers_1 = require("../screens/Follow/Followers");
const DetailNotiScreen_1 = require("../screens/Noti/DetailNotiScreen");
const NotificationScreen_1 = __importDefault(require("../screens/Noti/NotificationScreen/NotificationScreen"));
const scale_1 = require("../utils/scale");
const Routes_1 = __importDefault(require("./Routes"));
const screens_1 = require("../screens");
const DetailCommentArticle_1 = require("../screens/ArticleScreen/DetailCommentArticle");
const NotiStack = (0, native_stack_1.createNativeStackNavigator)();
const NotiNavigator = () => {
    const { width } = (0, react_native_1.useWindowDimensions)();
    const getDisplayWidth = () => {
        if (react_native_1.Platform.OS !== "web") {
            return null;
        }
        if ((0, scale_1.checkDeviceScreen)(width) === scale_1.DeviceScreen.MOBILE ||
            (0, scale_1.checkDeviceScreen)(width) === scale_1.DeviceScreen.UL_MOBILE ||
            (0, scale_1.checkDeviceScreen)(width) === scale_1.DeviceScreen.TABLET) {
            return "0%";
        }
        return "10%";
    };
    return (react_1.default.createElement(NotiStack.Navigator, { screenOptions: {
            headerShown: false,
            contentStyle: react_native_1.Platform.OS === 'web' && {
                paddingHorizontal: getDisplayWidth(),
                backgroundColor: '#FCF9F2',
            },
        } },
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.NOTIFICATION_SCREEN, component: NotificationScreen_1.default }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.DETAIL_NOTI_SCREEN, component: DetailNotiScreen_1.DetailNotiScreen }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.FOLLOW_TAG, component: FollowTag_1.FollowTag }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.FOLLOW, component: Follow_1.Follow }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.FOLLOWERS, component: Followers_1.Followers }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.FOLLOW_SCREEN, component: FollowScreen_1.default }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.HOME_ARTICLE_DETAIL, component: screens_1.DetailHomeScreen }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.DETAIL_STORY, component: screens_1.DetailStoryScreen }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.LIST_COMMENT_ARTICLE, component: screens_1.ListCommentScreen }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.DETAIL_COMMENT_ARTICLE, component: DetailCommentArticle_1.DetailCommentArticle }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.MIND_MAP_SCREEN, component: screens_1.MindMapScreen }),
        react_1.default.createElement(NotiStack.Screen, { name: Routes_1.default.URL_NOT_FOUND, component: screens_1.NotFoundScreen })));
};
exports.default = NotiNavigator;
